(function () {
  function initFeaturedCollection(root) {
    var sliderEl = root.querySelector('[data-featured-collection-slider]');
    if (!sliderEl) return;

    var perMobile = parseFloat(sliderEl.getAttribute('data-preview-mobile') || '1.6');
    var perMobileBig = parseFloat(sliderEl.getAttribute('data-preview-mobile-big') || '2.6');
    var perDesktop = parseFloat(sliderEl.getAttribute('data-preview-desktop') || '4');

    perMobile = Math.max(perMobile, 1.6);

    var nextBtns = root.querySelectorAll('[data-featured-collection-next]');
    var prevBtns = root.querySelectorAll('[data-featured-collection-prev]');
    var paginationEl = root.querySelector('[data-featured-collection-pagination]');

    if (!window.Swiper) return;
    var swiperContainer = sliderEl.matches('.swiper, .swiper-container') ? sliderEl : (sliderEl.querySelector('.swiper, .swiper-container') || sliderEl);
    if (swiperContainer.classList.contains('swiper-initialized') || sliderEl.classList.contains('swiper-initialized')) return;

    var swiper = new Swiper(swiperContainer, {
      speed: 350,
      spaceBetween: 20,
      slidesPerView: 2,
      watchOverflow: true,
      threshold: 5,
      touchRatio: 1,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      touchStartPreventDefault: true,
      preventClicks: true,
      preventClicksPropagation: true,
      mousewheel: {
        releaseOnEdges: true,
        sensitivity: 1,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      pagination: paginationEl ? { el: paginationEl, type: 'progressbar' } : undefined,
      breakpoints: {
        320: { slidesPerView: perMobile, spaceBetween: 12 },
        640: { slidesPerView: 2, spaceBetween: 16 },
        768: { slidesPerView: perMobileBig, spaceBetween: 16 },
        1024: { slidesPerView: perDesktop, spaceBetween: 20 },
      },
    });

    function updateNavButtons() {
      var isBeginning = swiper.isBeginning;
      var isEnd = swiper.isEnd;
      prevBtns.forEach(function (btn) {
        btn.classList.toggle('swiper-button-disabled', isBeginning);
        if (btn.tagName === 'BUTTON') btn.disabled = isBeginning;
      });
      nextBtns.forEach(function (btn) {
        btn.classList.toggle('swiper-button-disabled', isEnd);
        if (btn.tagName === 'BUTTON') btn.disabled = isEnd;
      });
    }

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        swiper.slidePrev();
      });
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        swiper.slideNext();
      });
    });

    swiper.on('slideChange', updateNavButtons);
    swiper.on('init', updateNavButtons);
    updateNavButtons();
  }

  function initFeaturedCollectionWishlist(root) {
    var storageKey = 'featured-collection-wishlist';
    var buttons = root.querySelectorAll('[data-wishlist-button]');
    if (!buttons.length) return;

    var wishlist = [];
    try {
      wishlist = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(wishlist)) wishlist = [];
    } catch (e) {
      wishlist = [];
    }

    function saveWishlist() {
      try {
        localStorage.setItem(storageKey, JSON.stringify(wishlist));
      } catch (e) {}
    }

    function updateButtonState(button) {
      var productId = button.getAttribute('data-product-id');
      if (!productId) return;
      var isActive = wishlist.includes(productId);
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.setAttribute('title', isActive ? 'Remove from wishlist' : 'Add to wishlist');
    }

    function updateAllButtons() {
      root.querySelectorAll('[data-wishlist-button]').forEach(updateButtonState);
    }

    updateAllButtons();

    if (root.dataset.wishlistBound === 'true') return;
    root.dataset.wishlistBound = 'true';

    root.addEventListener('click', function (event) {
      var button = event.target && event.target.closest ? event.target.closest('[data-wishlist-button]') : null;
      if (!button || !root.contains(button)) return;

      event.preventDefault();

      var productId = button.getAttribute('data-product-id');
      if (!productId) return;

      if (wishlist.includes(productId)) {
        wishlist = wishlist.filter(function (id) {
          return id !== productId;
        });
      } else {
        wishlist.push(productId);
      }

      saveWishlist();
      updateAllButtons();
    });
  }

  function initRoot(root) {
    initFeaturedCollectionWishlist(root);

    function waitForSwiper() {
      if (window.Swiper) {
        initFeaturedCollection(root);
        return;
      }
      window.setTimeout(waitForSwiper, 60);
    }

    waitForSwiper();
  }

  function boot() {
    document.querySelectorAll('[data-featured-collection]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:section:select', boot);
  }
})();
